// extracted by mini-css-extract-plugin
module.exports = {"container":"Read_container__2mI3I","reader":"Read_reader__3TSuN","para":"Read_para__1M11o","button":"Read_button__1HU_M","loader":"Read_loader__2HYEM"};